import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiHelper } from '@sc/pas-common';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ProducerService } from '@sc/pas-common';

@Component({
    moduleId: module.id,
    templateUrl: './impersonated-login.component.html',
    styleUrls: ['./impersonated-login.component.scss']
})

export class ImpersonatedLoginComponent implements OnInit {
    producerCodeErrors = { invalid: 'El N° de productor no existe', required: 'Escribí un N° de productor' }
    usernameErrors = { invalid: 'El usuario no existe', required: 'Escribí un usuario' }
    producerForm: FormGroup;
    usernameForm: FormGroup;
    branches = [];
    loadingUsernames = false;
    loadingLogin = false;
    invalidUsername = false;
    invalidProducerCode = false;
    isUserDisabled = true;
    usernames$: BehaviorSubject<any>;
    selectedItem: any;
    tabs = [
        {
            id: 'Tab1',
            label: 'Productor'
        },
        {
            id: 'Tab2',
            label: 'Usuario'
        }
    ];

    constructor(private readonly apiHelper: ApiHelper, private readonly httpClient: HttpClient, private readonly producerService: ProducerService) {
        for (let index = 1; index <= 9; index++) {
            let number = '0' + index;
            this.branches.push({ key: index, value: number })
        }
        this.usernames$ = new BehaviorSubject<any>([]);
        this.selectedItem = this.tabs[0];

    }

    ngOnInit() {
        this.initializeProducerCodeForm();
        this.initializeUsernameForm();

        this.producerForm.controls.producerCode.valueChanges.pipe(
            debounceTime(800),
            distinctUntilChanged())
            .subscribe(
                () => {
                    this.getUsersByProducerCode();
                }
            );
        this.producerForm.controls.branchCode.valueChanges
            .subscribe(
                () => {
                    this.getUsersByProducerCode();
                }
            );

        this.usernameForm.controls.username.valueChanges
            .subscribe(() => {
                this.invalidUsername = false;
            });
    }

    private getUsersByProducerCode() {
        this.producerForm.controls.username.reset();
        if (this.producerForm.controls.branchCode.value && this.producerForm.controls.producerCode.value) {
            this.invalidProducerCode = false;
            this.loadingUsernames = true;
            this.producerService.getUsersByProducerCode(this.producerForm.controls.branchCode.value.value + "-" + this.producerForm.controls.producerCode.value.padStart(6, '0')).subscribe((data: string[]) => {
                this.usernames$.next(data.map(user => { return { key: user, value: user }; }));
                this.isUserDisabled = false;
            }, () => {
                this.invalidProducerCode = true;
                this.usernames$.next([]);
                this.isUserDisabled = true;
            }).add(() => {
                this.loadingUsernames = false;
                this.producerForm.controls.producerCode.updateValueAndValidity();
            });
        }
        else
            this.usernames$.next([]);
    }

    loginUsernameByProducerCode()
    {
        var usernameObject = this.producerForm.controls.username.value;
        this.loginUsername(usernameObject.value);
    }

    initializeProducerCodeForm() {
        this.producerForm = new FormGroup({
            branchCode: new FormControl(),
            producerCode: new FormControl(),
            username: new FormControl()
        });

        this.producerForm.controls.branchCode.setValue(this.branches[0]);
        this.producerForm.controls.producerCode.setValidators([Validators.required, this.ProducerCodeValidator]);
        this.producerForm.controls.username.setValidators([Validators.required]);
        this.producerForm.controls.producerCode.updateValueAndValidity();
        this.producerForm.controls.username.updateValueAndValidity();
    }

    initializeUsernameForm() {
        this.usernameForm = new FormGroup({
            username: new FormControl()
        });

        this.usernameForm.controls.username.setValidators([Validators.required, this.UsernameValidator]);
        this.usernameForm.controls.username.updateValueAndValidity();
    }

    loginUsername(username) {
        this.loadingLogin = true;
        this.apiHelper.loginImpersonation(username).subscribe(response => {
            this.redirectLogin(response);
        },
            () => {
                this.setInvalidUsername();
            }).add(() => {
                this.loadingLogin = false
            });
    }

    selectTab(value) {
        this.selectedItem = value;
    }

    setInvalidUsername() {
        if (this.usernameForm.controls.username.value) {
            this.invalidUsername = true;
            this.usernameForm.controls.username.updateValueAndValidity();
        }
    }

    redirectLogin(response) {
        const options = null;
        this.apiHelper.redirectLogin(response.data, options);
    }

    ProducerCodeValidator = (c: FormControl) => {
        if (this.invalidProducerCode) {
            let err;
            err = {
                invalid: true
            };
            return err;
        }
        else
            return;
    }

    UsernameValidator = (c: FormControl) => {
        if (this.invalidUsername) {
            let err;
            err = {
                invalid: true
            };
            return err;
        }
        else
            return;
    }
}
